module.exports = __webpack_public_path__ + "img/left.e1bf68c8.svg";